// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hrsettingspg-inline-1 {
  display: flex;
  gap: 8px;
}

.hrsettingspg-inline-2 {
  padding: 0;
}

.hrsettingspg-inline-3 {
  width: 100%;
}

.hrsettingspg-inline-4 {
  font-weight: 600;
}

.hrsettingspg-inline-5 {
  width: 80px;
  padding: 4px 8px;
}

.hrsettingspg-inline-6 {
  width: 32px;
  height: 24px;
  border: none;
  cursor: pointer;
}

.hrsettingspg-inline-7 {
  color: #ef4444;
  border-color: #fecaca;
}

.hrsettingspg-inline-8 {
  text-align: center;
  padding: 20px;
  color: #94a3b8;
}

.hrsettingspg-inline-9 {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.hrsettingspg-inline-10 {
  width: 80px;
}

.hrsettingspg-inline-11 {
  width: 80px;
}

.hrsettingspg-inline-12 {
  width: 80px;
}

.hrsettingspg-inline-13 {
  padding: 20px;
  text-align: center;
  color: #999;
}

.hrsettingspg-inline-14 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.hrsettingspg-inline-15 {
  padding: 2px 8px;
  font-size: 10px;
}

.hrsettingspg-inline-16 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/HR/HrSettingsPg.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":[".hrsettingspg-inline-1 {\n  display: flex;\n  gap: 8px;\n}\n\n.hrsettingspg-inline-2 {\n  padding: 0;\n}\n\n.hrsettingspg-inline-3 {\n  width: 100%;\n}\n\n.hrsettingspg-inline-4 {\n  font-weight: 600;\n}\n\n.hrsettingspg-inline-5 {\n  width: 80px;\n  padding: 4px 8px;\n}\n\n.hrsettingspg-inline-6 {\n  width: 32px;\n  height: 24px;\n  border: none;\n  cursor: pointer;\n}\n\n.hrsettingspg-inline-7 {\n  color: #ef4444;\n  border-color: #fecaca;\n}\n\n.hrsettingspg-inline-8 {\n  text-align: center;\n  padding: 20px;\n  color: #94a3b8;\n}\n\n.hrsettingspg-inline-9 {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.hrsettingspg-inline-10 {\n  width: 80px;\n}\n\n.hrsettingspg-inline-11 {\n  width: 80px;\n}\n\n.hrsettingspg-inline-12 {\n  width: 80px;\n}\n\n.hrsettingspg-inline-13 {\n  padding: 20px;\n  text-align: center;\n  color: #999;\n}\n\n.hrsettingspg-inline-14 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.hrsettingspg-inline-15 {\n  padding: 2px 8px;\n  font-size: 10px;\n}\n\n.hrsettingspg-inline-16 {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
